import { render, staticRenderFns } from "./DepartmentInput.vue?vue&type=template&id=886214c0&"
import script from "./DepartmentInput.vue?vue&type=script&lang=js&"
export * from "./DepartmentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports